import { SharedCostRuleComponent } from '../shared-cost-rule.component';

export interface SCRFocusStrategy {
  componentInstance: SharedCostRuleComponent;
  activate: (focusedSegmentIndex?: number) => void;
  moveFocus: (isForward: boolean) => void;
  selectElement: () => void;
  unselectElement: () => void;
}
